module.exports = __webpack_public_path__ + "img/OLIMP.KZ.b14b9d6b.svg";